/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import Cookies from 'universal-cookie';

const cookies = new Cookies();

/**
 * @description Get a single or multiple cookies by value.
 * @argument {string|[string]} name - The name of the cookie.
 * @returns {string|[string]}
 */

function getCookieByName(name) {
    if (!name) {
        return 'cookie looked up with no name';
    }

    if (typeof name === 'string') {
        return cookies.get(name) || 'cookie not found';
    }

    if (Array.isArray(name)) {
        const output = [];

        name.forEach((n) => {
            output.push(cookies.get(n) || 'cookie not found');
        });

        return output;
    }

    return `${name} cookie not found`;
}

export default getCookieByName;
